<div class="th--name_and_sort--sort_arrows flex_align_center pl-10" *ngIf="accessToShowSortArrows">
    <img src="assets/images/icons/arrow_less_black.svg"
         *ngIf="direction === 'ASC'">
    <img src="assets/images/icons/arrow_more_black.svg"
         *ngIf="direction === 'DESC'">
</div>
